'use client';

import { Box, Typography } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { LandingAdvertisementProps } from './types';
import { AdTag } from './Advertisement.parts';

import { Image, Link } from '@/shared/Components';

const Advertisement = ({
  mainDescription,
  subDescription,
  mobileDescription,
  imgSrc,
  link,
  variant,
  onClick,
}: LandingAdvertisementProps) => {
  return (
    <Link
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="relative block"
      data-testid={`advertisement-${variant}`}
      onClick={onClick}
    >
      <Box
        className={twJoin(
          'flex h-[112px] items-center justify-center gap-4 rounded-2xl bg-primary-50 py-5 pl-6 pr-4',
          'tablet:h-[120px] tablet:gap-8 tablet:py-6 tablet:pl-8 tablet:pr-6'
        )}
      >
        <Box className="tablet:hidden">
          <Typography
            variant="body1"
            className="break-keep font-bold text-w-gray-900"
          >
            {mobileDescription}
          </Typography>
        </Box>
        <Box
          className={twJoin(
            'hidden justify-between',
            'tablet:flex tablet:max-w-[680px] tablet:flex-col tablet:gap-1',
            'desktop:w-[552px]'
          )}
        >
          <Typography variant="body1" className="text-w-gray-700">
            {subDescription}
          </Typography>
          <Typography variant="subTitle2" className="font-bold text-w-gray-900">
            {mainDescription}
          </Typography>
        </Box>
        <Image src={imgSrc} alt={variant} width={120} height={70} />
      </Box>
      <Box className="absolute right-3 top-3">
        <AdTag />
      </Box>
    </Link>
  );
};

export default Advertisement;
